import React from 'react';
import './Syles/Prototyping.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
const Prototyping=(props)=>{
    return(
        <div  className={`prototyping-home ${props.styles}`}>
          <div className="content">
              <h1>{props.title}</h1>
              <p>{props.desc}</p>
              <StyledButton 
              btn={props.btn}
              styles="nobg-btn"
              />
          </div>
          <div className="image-part">
              <div className="card" data-aos="zoom-in"
              data-aos-delay={300}>
                <h3>Background</h3>
                <div className="circles">
                    <h2>91F2F6</h2>
                    <div className="circle"></div>
                    <div className="circle circle2"></div>
                  </div>
                  <div className="labels">
                      <p>Screen lables</p>
                      <p className="link">Manage</p>
                  </div>
                  <div className="buttons">
                      <div className="btngroup">
                          In Progress
                      </div>
                      <div className="btngroup group2">
                          Need Review
                      </div>
                      <div className="btngroup group 3">
                        Completed
                      </div>
                  </div>
              </div>
          </div>
        </div>
    )
};
export default Prototyping;